import SectionCls from "@outschool/section";
import UserCls from "@outschool/user";

export const Section = new SectionCls();
export const User = new UserCls();
